/**
 * Small fetch wrapper.
 *
 * - Same-origin by default (backend is either the Express server itself in
 *   production, or proxied through Vite in development — see vite.config.js).
 * - Cookies included on every request (JWT session cookie).
 * - JSON headers set automatically; content-type of the response is sniffed
 *   so text/html/plain responses come back as strings.
 * - Non-2xx responses throw an ApiError with the parsed body attached.
 */
export class ApiError extends Error {
  constructor(status, body) {
    const msg = (body && typeof body === 'object' && body.error) || `HTTP ${status}`;
    super(msg);
    this.name = 'ApiError';
    this.status = status;
    this.body = body;
  }
}

export async function api(path, options = {}) {
  const { method = 'GET', body, headers = {}, ...rest } = options;

  const init = {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      ...(body !== undefined ? { 'Content-Type': 'application/json' } : {}),
      ...headers,
    },
    ...rest,
  };
  if (body !== undefined) {
    init.body = typeof body === 'string' ? body : JSON.stringify(body);
  }

  const res = await fetch(path, init);
  const parsed = await parseBody(res);

  if (!res.ok) throw new ApiError(res.status, parsed);
  return parsed;
}

async function parseBody(res) {
  if (res.status === 204) return null;
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) return res.json();
  return res.text();
}
